import {
  findPremissionIsCLientRole,
  findPremissionIsCompanyRole,
} from "../Users/UserSecurityFind";
import { Path } from "react-router-dom";

const permissionMap: { permissions: string[]; route: string }[] = [
  // Dashboard
  { permissions: ["Dashboard.View"], route: "dashboard" },

  // Party
  { permissions: ["Master.Ledger.Party.View"], route: "party/parties" },
  { permissions: ["Master.Group.Party.View"], route: "party/partiesGroup" },

  // Item
  { permissions: ["Master.Item.View"], route: "item/items" },
  {
    permissions: ["Master.Item.Category.View"],
    route: "item/itemCategory",
  },
  { permissions: ["Master.Item.Unit.View"], route: "item/units" },
  {
    permissions: ["Master.Item.Locations.View"],
    route: "item/itemlocations",
  },

  // Sales
  { permissions: ["Voucher.Sales.Invoice.View"], route: "sales/invoices" },
  {
    permissions: ["Voucher.Sales.ProformaInvoice.View"],
    route: "sales/proformaInvoices",
  },
  {
    permissions: ["Voucher.Sales.CreditNote.View"],
    route: "sales/creditNotes",
  },
  { permissions: ["Voucher.Sales.Receipt.View"], route: "sales/receipts" },
  { permissions: ["Voucher.Sales.Estimate.View"], route: "sales/estimate" },
  { permissions: ["Voucher.Sales.SalesOrder.View"], route: "sales/order" },
  {
    permissions: ["Master.Ledger.Customer.View"],
    route: "sales/customers",
  },

  // Purchase
  {
    permissions: ["Voucher.Purchase.Bill.View"],
    route: "purchase/purchaseBill",
  },
  {
    permissions: ["Voucher.Purchase.DebitNote.View"],
    route: "purchase/debitNote",
  },
  {
    permissions: ["Voucher.Purchase.PaymentOut.View"],
    route: "purchase/paymentOut",
  },
  {
    permissions: ["Voucher.Purchase.PurchaseOrder.View"],
    route: "purchase/order",
  },
  {
    permissions: ["Master.Ledger.Suppliers.View"],
    route: "purchase/suppliers",
  },

  // Expenses & Income
  { permissions: ["Voucher.Expenses.View"], route: "expenses" },
  { permissions: ["Master.Ledger.Expenses.View"], route: "expensesLedger" },
  { permissions: ["Master.Group.Expenses.View"], route: "expensesGroup" },
  { permissions: ["Voucher.Income.View"], route: "income" },
  { permissions: ["Master.Ledger.Income.View"], route: "incomeLedger" },
  { permissions: ["Master.Group.Income.View"], route: "incomeGroup" },

  // Journals
  { permissions: ["Voucher.Journals.View"], route: "journals" },

  // Banking
  { permissions: ["Voucher.Contra.View"], route: "banking/bankAccounts" },
  {
    permissions: ["Master.Ledger.Bank.View"],
    route: "banking/bankAccounts",
  },
  { permissions: ["Master.Ledger.Cash.View"], route: "banking/cashInHand" },
  {
    permissions: ["BankReconciliation.View"],
    route: "banking/bankReconciliation",
  },
  { permissions: ["Cheque.View"], route: "banking/cheque" },

  // Fixed Asset
  { permissions: ["Voucher.Asset.FixedAsset.View"], route: "asset/fixedAsset" },

  // Draft
  {
    permissions: [
      "Voucher.Sales.Invoice.View",
      "Voucher.Sales.ProformaInvoice.View",
      "Voucher.Sales.CreditNote.View",
      "Voucher.Sales.Receipt.View",
      "Voucher.Sales.Estimate.View",
      "Voucher.Sales.SalesOrder.View",
      "Voucher.Purchase.Bill.View",
      "Voucher.Purchase.DebitNote.View",
      "Voucher.Purchase.PaymentOut.View",
      "Voucher.Purchase.PurchaseOrder.View",
      "Voucher.Expenses.View",
      "Voucher.Income.View",
      "Voucher.Journal.View",
      "Voucher.Contra.View",
      "Voucher.Asset.FixedAsset.View",
    ],
    route: "draft",
  },

  // Registers
  {
    permissions: [
      "Voucher.Sales.Invoice.View",
      "Voucher.Sales.ProformaInvoice.View",
      "Voucher.Sales.CreditNote.View",
      "Voucher.Sales.Receipt.View",
      "Voucher.Sales.Estimate.View",
      "Voucher.Sales.SalesOrder.View",
      "Voucher.Purchase.Bill.View",
      "Voucher.Purchase.DebitNote.View",
      "Voucher.Purchase.PaymentOut.View",
      "Voucher.Purchase.PurchaseOrder.View",
      "Voucher.Expenses.View",
      "Voucher.Income.View",
      "Voucher.Journal.View",
      "Voucher.Contra.View",
      "Voucher.Asset.FixedAsset.View",
    ],
    route: "registers",
  },

  // Reports
  {
    permissions: [
      "Report.BalanceSheet.View",
      "Report.P&L.View",
      "Report.TrialBalance.View",
      "Report.CashFlow.View",
      "Report.DebtorsAgeing.View",
      "Report.CreditorsAgeing.View",
      "Report.CustomerOutstanding.View",
      "Report.SupplierOutstanding.View",
      "Report.GeneralLedger.View",
      "Report.FixedAssets.View",
      "Report.BankReconciliation.View",
      "Report.GST.View",
      "Report.TcsTds.View",
    ],
    route: "reports",
  },

  // Master
  { permissions: ["Master.Ledger.View"], route: "master/ledger" },
  { permissions: ["Master.Group.View"], route: "master/group" },

  // Settings
  {
    permissions: [
      "Setting.Company.Info.View",
      "Setting.Company.Details.View",
      "Setting.Company.PaymentTerm.View",
      "Setting.Company.GST.View",
    ],
    route: "settings/companyInfo",
  },
  {
    permissions: [
      "Setting.Voucher.Sales.View",
      "Setting.Voucher.ProformaInvoice.View",
      "Setting.Voucher.CreditNote.View",
      "Setting.Voucher.Receipt.View",
      "Setting.Voucher.Estimate.View",
      "Setting.Voucher.SalesOrder.View",
      "Setting.Voucher.Bill.View",
      "Setting.Voucher.DebitNote.View",
      "Setting.Voucher.PaymentOut.View",
      "Setting.Voucher.PurchaseOrder.View",
      "Setting.Voucher.Expenses.View",
      "Setting.Voucher.Income.View",
      "Setting.Voucher.Contra.View",
      "Setting.Voucher.Journal.View",
      "Setting.Voucher.FixedAsset.View",
    ],
    route: "settings/vouchers",
  },
  { permissions: ["Setting.Item.View"], route: "settings/items" },
  {
    permissions: ["Setting.OpeningBalance.View"],
    route: "settings/openingBalance",
  },
  { permissions: ["Setting.Templates.View"], route: "settings/templates" },
  {
    permissions: ["Setting.DefaultLedger.View"],
    route: "settings/defaultLedger",
  },
  {
    permissions: [
      "Setting.TC.Sales.View",
      "Setting.TC.ProformaInvoice.View",
      "Setting.TC.CreditNote.View",
      "Setting.TC.Receipt.View",
      "Setting.TC.Estimate.View",
      "Setting.TC.SalesOrder.View",
      "Setting.TC.Bill.View",
      "Setting.TC.DebitNote.View",
      "Setting.TC.PaymentOut.View",
      "Setting.TC.PurchaseOrder.View",
      "Setting.TC.Expenses.View",
      "Setting.TC.Income.View",
      "Setting.TC.Contra.View",
      "Setting.TC.Journal.View",
      "Setting.TC.FixedAsset.View",
    ],
    route: "settings/termsandConditions",
  },
  { permissions: ["Setting.TDS.View"], route: "settings/tds" },
  {
    permissions: ["Setting.Currencies.View"],
    route: "settings/currencies",
  },
  { permissions: ["settings.Lockmonth.View"], route: "settings/lockmonth" },
];

const NavLinkPathIsCompanyRole = (
  clientId: string,
  clientSpecificRole?: boolean
) => {
  let showType: string | Partial<Path> = "";
  if (!clientSpecificRole) {
    for (const entry of permissionMap) {
      if (findPremissionIsCompanyRole(entry.permissions)) {
        showType = entry.route;
        break;
      }
    }
  } else {
    for (const entry of permissionMap) {
      if (findPremissionIsCLientRole(entry.permissions, clientId)) {
        showType = entry.route;
        break;
      }
    }
  }
  return `/billing/clients/${clientId}/${showType}`;
};

export default NavLinkPathIsCompanyRole;
